import React from 'react';
import PropTypes from 'prop-types';

import AIFileDescriptionLayout from './AIFileDescriptionLayout';

/**
 * Default fallback layout for AI file descriptions
 * Uses the comprehensive AI File Description layout as the default experience
 * This provides the full-featured timeline and analysis view for most cases
 */
const DefaultLayout = (props) => {
  // Use the original comprehensive AI File Description layout as default
  return <AIFileDescriptionLayout {...props} />;
};

DefaultLayout.propTypes = {
  analyticData: PropTypes.object.isRequired,
  fetchData: PropTypes.func.isRequired,
  issue: PropTypes.object.isRequired,
  fetchStatus: PropTypes.func.isRequired,
  rerunDataAnalysis: PropTypes.func.isRequired,
};

export default DefaultLayout;
